import React from 'react';
import { ExternalLink, MoreVertical } from 'lucide-react';
import { cn } from '../../lib/utils';
import CardMenu from './CardMenu';

/**
 * Card chrome — white fill, hairline border, 22px radius, soft shadow.
 */
export default function LabCard({
  title,
  description,
  accentColor = '#0099FF',
  initial,
  badge,
  selected = false,
  showExternal = false,
  showMenu = false,
  menuItems,
  onClick,
  className,
  as: Component = 'div',
}) {
  const letter = initial || title?.[0]?.toUpperCase() || '?';

  return (
    <Component
      type={Component === 'button' ? 'button' : undefined}
      onClick={onClick}
      className={cn(
        'text-left p-5 bg-elevated border shadow-soft transition-all duration-200 hover:border-ink/20',
        selected ? 'border-space' : 'border-shell-card-border',
        onClick && Component === 'button' ? 'cursor-pointer w-full' : '',
        className,
      )}
      style={{ borderRadius: 14 }}>
      <div className="flex items-start justify-between mb-4">
        <div
          className="w-10 h-10 rounded-full flex items-center justify-center"
          style={{ backgroundColor: `${accentColor}1A` }}>
          <span className="text-sm font-extrabold" style={{ color: accentColor }}>
            {letter}
          </span>
        </div>
        <div className="flex items-center gap-2">
          {badge ? (
            <span className="text-[12.5px] font-medium px-2.5 py-0.5 rounded-full bg-paper border border-shell-border text-ink">
              {badge}
            </span>
          ) : null}
          {showExternal ? <ExternalLink className="w-3.5 h-3.5 text-muted-dim" /> : null}
          {menuItems?.filter(Boolean)?.length ? (
            <CardMenu items={menuItems} />
          ) : showMenu ? (
            <span className="text-muted-dim">
              <MoreVertical className="w-4 h-4" />
            </span>
          ) : null}
        </div>
      </div>
      {title ? <h3 className="text-base font-extrabold text-ink mb-2 truncate tracking-tight">{title}</h3> : null}
      {description ? (
        <p className="text-sm text-mute leading-relaxed line-clamp-2">{description}</p>
      ) : null}
    </Component>
  );
}
